import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import type { JSX } from 'react';
import { ApiError } from '../api/client.js';

/** Estados obrigatórios de toda tela: loading, vazio, erro recuperável, sucesso. */
export function AsyncSection<T>({
  query,
  emptyMessage,
  children,
}: {
  query: { isLoading: boolean; error: unknown; data: T | undefined; refetch: () => void };
  emptyMessage: string;
  children: (data: T) => ReactNode;
}): JSX.Element {
  if (query.isLoading) {
    return (
      <Box sx={{ display: 'grid', placeItems: 'center', py: 6 }}>
        <CircularProgress aria-label="Carregando" />
      </Box>
    );
  }
  if (query.error) {
    const error = query.error;
    const message = error instanceof ApiError ? error.message : 'Não foi possível carregar os dados.';
    const retryable = error instanceof ApiError ? error.retryable : true;
    return (
      <Alert
        severity="error"
        action={
          retryable ? (
            <Typography
              component="button"
              onClick={() => query.refetch()}
              sx={{ background: 'none', border: 0, cursor: 'pointer', fontWeight: 600, color: 'inherit' }}
            >
              Tentar novamente
            </Typography>
          ) : undefined
        }
      >
        {message}
      </Alert>
    );
  }
  if (query.data === undefined || (Array.isArray(query.data) && query.data.length === 0)) {
    return <Alert severity="info">{emptyMessage}</Alert>;
  }
  return <>{children(query.data)}</>;
}